{
  "header": {
    "history": "Lịch sử",
    "viewInvoice": "Xem hoá đơn"
  },
  "suggestions": {
    "greeting": "Hôm nay bạn cần gì?",
    "subtitle": "Bấm vào một gợi ý để bắt đầu: mình có thể giúp tạo hoá đơn, ghi chi phí, tra cứu khách, và nhiều hơn.",
    "categories": {
      "invoice": "Hoá đơn",
      "expense": "Chi phí & doanh thu",
      "client": "Khách & công nợ",
      "tax": "Sổ sách & báo cáo"
    }
  },
  "input": {
    "attach": "Đính kèm file",
    "dropFiles": "Thả file để tải lên",
    "placeholder": "Paste tin nhắn Zalo hoặc nhập yêu cầu tạo hoá đơn...",
    "enterToSend": "gửi",
    "shiftEnterNewline": "xuống dòng",
    "fileHint": "hãy thêm file",
    "dismissFileHint": "Bỏ nhắc đính kèm file"
  },
  "actions": {
    "editManual": "Chỉnh sửa thủ công",
    "approveQR": "Phê duyệt & Tạo VietQR",
    "sendZalo": "Gửi qua Zalo",
    "copyJSON": "Sao chép JSON",
    "regenerate": "Tạo lại"
  },
  "artifact": {
    "title": "Xem trước hoá đơn",
    "draft": "Nháp",
    "close": "Đóng",
    "missingInfo": "Thiếu thông tin:",
    "helpText": "Bạn có thể tiếp tục chat để chỉnh sửa, hoặc nhấn \"Phê duyệt\" để tạo VietQR và gửi cho khách.",
    "emptyTitle": "Gửi tin nhắn để tạo hoá đơn.",
    "emptySubtitle": "Hoá đơn sẽ hiển thị ở đây.",
    "viewInvoice": "Xem hoá đơn #{{id}}",
    "approving": "Đang xử lý...",
    "editManual": "Sửa thủ công",
    "downloadPDF": "Tải PDF",
    "invoice": "Hoá đơn",
    "createdDate": "Ngày tạo",
    "client": "Khách hàng",
    "details": "Chi tiết",
    "subtotal": "Tạm tính",
    "vat": "VAT ({{rate}}%)",
    "balance": "Còn lại",
    "vietqr": "VietQR",
    "paymentRef": "Nội dung CK:",
    "qrPending": "QR sẽ được tạo khi phê duyệt",
    "unknownClient": "Chưa xác định",
    "sendEmail": "Gửi qua email",
    "markZalo": "Đánh dấu đã gửi qua Zalo",
    "sendReminder": "Gửi nhắc",
    "openInvoice": "Mở chi tiết hoá đơn",
    "draftLabel": "Nháp #{{n}}",
    "approveFailed": "Phê duyệt thất bại, thử lại",
    "extrasLocked": "Bán phụ chỉ có ở gói Pro. Nâng cấp để bật.",
    "marked": "Đã đánh dấu",
    "markFailed": "Đánh dấu thất bại, thử lại",
    "cancel": "Huỷ",
    "prev": "Hoá đơn trước",
    "next": "Hoá đơn sau",
    "markZaloConfirm": {
      "title": "Đánh dấu đã gửi qua Zalo?",
      "body": "Hành động này chuyển hoá đơn sang trạng thái 'Đang chờ thanh toán'. Dùng khi bạn đã share link/QR cho khách qua Zalo.",
      "action": "Xác nhận"
    },
    "qrBankNotLinked": "Chưa liên kết ngân hàng nên chưa tạo được QR thanh toán.",
    "qrUnsupportedBank": "Ngân hàng này chưa hỗ trợ tạo VietQR.",
    "linkBank": "Liên kết ngân hàng",
    "qrRetry": "Thử lại",
    "qrRetrying": "Đang thử...",
    "bankWarn": {
      "title": "Chưa liên kết ngân hàng",
      "body": "QR thanh toán cần một tài khoản ngân hàng. Liên kết ở Cài đặt → Ngân hàng, hoặc vẫn tạo hoá đơn (chưa có QR, có thể bổ sung sau khi liên kết).",
      "link": "Liên kết ngân hàng",
      "proceed": "Vẫn tạo hoá đơn"
    }
  },
  "threads": {
    "title": "Cuộc trò chuyện",
    "empty": "Chưa có cuộc trò chuyện nào",
    "newConversation": "Trò chuyện mới"
  }
}
